<admin-app-header></admin-app-header>

<div class="container-fluid">
    <div class="row py-3">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <h2><i class="fa-solid fa-code-branch me-2"></i>Changelog</h2>
                    <p class="text-muted mb-0">Platform version history and release notes.</p>
                </div>
                <span class="badge bg-primary fs-6">v{{ currentVersion }}</span>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="card mb-3" *ngFor="let entry of changelog">
                <div
                    class="card-header d-flex justify-content-between align-items-center"
                    style="cursor: pointer"
                    (click)="toggleVersion(entry.version)"
                >
                    <div>
                        <span class="badge me-2" [ngClass]="entry.version === currentVersion ? 'bg-primary' : 'bg-secondary'">
                            v{{ entry.version }}
                        </span>
                        <strong>{{ entry.summary }}</strong>
                    </div>
                    <div class="d-flex align-items-center">
                        <span class="text-muted me-3">{{ entry.date }}</span>
                        <i [class]="isExpanded(entry.version) ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                    </div>
                </div>
                <div class="card-body" *ngIf="isExpanded(entry.version)">
                    <div class="row">
                        <div class="col-md-6 mb-3" *ngFor="let section of entry.sections">
                            <h6 class="text-muted">
                                <i [class]="getSectionIcon(section.title)" class="me-2"></i>{{ section.title }}
                            </h6>
                            <ul class="changelog-list">
                                <li *ngFor="let item of section.items">{{ item }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
